const cacheNamePrefix = "t-shirt-memory-";

const hasServiceWorker = (): boolean =>
  Boolean(globalThis.navigator && "serviceWorker" in globalThis.navigator);

const removeDevelopmentServiceWorker = (): void => {
  hasServiceWorker()
    ? void globalThis.navigator.serviceWorker
        .getRegistrations()
        .then((registrations) =>
          Promise.all(
            registrations.map((registration) => registration.unregister()),
          ),
        )
        .then(() =>
          "caches" in globalThis
            ? globalThis.caches
                .keys()
                .then((cacheNames) =>
                  Promise.all(
                    cacheNames
                      .filter((cacheName) => cacheName.startsWith(cacheNamePrefix))
                      .map((cacheName) => caches.delete(cacheName)),
                  ),
                )
            : Promise.resolve([]),
        )
    : null;
};

const registerProductionServiceWorker = (): void => {
  hasServiceWorker()
    ? globalThis.addEventListener("load", () => {
        void globalThis.navigator.serviceWorker.register("/service-worker.js");
      })
    : null;
};

import.meta.env.PROD
  ? registerProductionServiceWorker()
  : removeDevelopmentServiceWorker();
